import React, { useState } from "react";
import { Icon } from "@iconify/react";

export default function ContractActions({
  onSave,
  onCancel,
  onCancelContract,
  isEdit,
  docStatus,
  isPaymentValid = true,
  isReadOnly = false,
}) {
  const [saving, setSaving] = useState(false);

  const handleSaveClick = async () => {
    if (saving || !isPaymentValid) return;
    try {
      setSaving(true);
      await onSave?.();
    } catch (err) {
      console.error("Error saving contract:", err);
    } finally {
      setSaving(false);
    }
  };

  const showCancelContract = isEdit && Number(docStatus) !== 4;

  return (
    <div
      className={`flex items-center mt-6 border-t pt-4 ${
        showCancelContract ? "justify-between" : "justify-end"
      }`}
    >

      {/* ⭐ ปุ่มยกเลิกสัญญา (เฉพาะโหมดแก้ไข + Doc_Status != 4) */}
      {showCancelContract && (
        <button
          onClick={onCancelContract}
          className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-md font-medium shadow transition"
        >
          <Icon icon="mdi:file-cancel-outline" className="w-5 h-5" />
          ยกเลิกสัญญา
        </button>
      )}

      {/* ⭐ ปุ่มด้านขวา */}
      <div className="flex gap-3">
        {/* ปุ่มยกเลิกหน้า */}
        <button
          onClick={onCancel}
          className="flex items-center gap-2 bg-gray-300 hover:bg-gray-400 text-gray-800 px-5 py-2.5 rounded-md font-medium transition"
        >
          <Icon icon="mdi:close-circle-outline" className="w-5 h-5" />
          {isReadOnly ? "ปิด" : "ยกเลิก"}
        </button>

        {/* ปุ่มบันทึก - ซ่อนเมื่อ isReadOnly */}
        {!isReadOnly && (
          <button
            onClick={handleSaveClick}
            disabled={saving || !isPaymentValid}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-md font-medium transition ${
              saving || !isPaymentValid
                ? "bg-gray-400 cursor-not-allowed text-white"
                : "bg-[#E13F57] hover:bg-[#c53048] text-white shadow"
            }`}
            title={!isPaymentValid ? "ผลรวมการชำระเงินไม่ตรงกับยอดรวมท้ายบิล" : ""}
          >
            <Icon icon="mdi:content-save-outline" className="w-5 h-5" />
            {saving ? "กำลังบันทึก..." : "บันทึก"}
          </button>
        )}
      </div>
    </div>
  );
}
